export default __webpack_public_path__ + "static/media/s-payment.53e50527.png";